import makeApiRequest, { DownloadOption, makeApiRequestOpenInTab } from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { ENTITIES, QuerybuilderModel } from 'src/models/QuerybuilderModel';
import { DELIVERY_TYPE, DownloadOptionsModel } from 'src/models/DownloadModel';

export const getEntitiesData =
  (organisation: string, entity: ENTITIES, query:QuerybuilderModel) => makeApiRequest({
    method: 'POST',
    url: `${API_URL.querybuilder}${entity}?debug=1`,
    data: query,
    organisation: organisation || 'aic',
  });

export const postDownloadEntitesData =
  (
    organisation: string,
    entity: ENTITIES,
    query: QuerybuilderModel,
    options: DownloadOptionsModel,
    downloadOption?: DownloadOption,
  ) => makeApiRequest(
    {
      method: 'POST',
      url: `${API_URL.querybuilder}${entity}?delivery=${options.delivery}`,
      data: query,
      organisation: organisation || 'aic',
    },
    options.delivery === DELIVERY_TYPE.tab ? DownloadOption.tab : downloadOption,
    options.file,
  );

export const postDownloadAmbassadorData =
  (
    organisation: string,
    fundraisindID: string,
    options: DownloadOptionsModel,
    downloadOption?: DownloadOption,
  ) => makeApiRequest(
    {
      method: 'POST',
      url: `${API_URL.ambassador}/event/${fundraisindID}/download?delivery=${options.delivery}`,
      data: { options },
      organisation: organisation || 'aic',
    },
    downloadOption,
    options.file,
  );

export const postEmailEntitiesData =
  (organisation: string,
    entity: ENTITIES,
    query:QuerybuilderModel,
    options: DownloadOptionsModel) => makeApiRequest({
    method: 'POST',
    url: `${API_URL.querybuilder}${entity}?delivery=${options.delivery}`,
    data: query,
    organisation: organisation || 'aic',
  });

export const postOpenTabEntityData = (
  organisation: string,
  entity: ENTITIES,
  query: QuerybuilderModel,
) => makeApiRequestOpenInTab({
  method: 'POST',
  url: `${API_URL.querybuilder}${entity}`,
  data: query,
  organisation: organisation || 'aic',
});
